import { ResolveFn } from '@angular/router';
import { CasiStoryPriority } from '../models/models.lib';
import { inject } from '@angular/core';
import { UserStoryPriorityService } from '../tracker/user-story-priority.service';

export const casiStoryPrioritiesResolver: ResolveFn<CasiStoryPriority> = (route, state) => {
  return inject(UserStoryPriorityService).get();
};
